export const RateTermsCountryCodes = {
  US: 'us',
  CA: 'ca',
  AU: 'au',
  NZ: 'nz',
};
